import React from "react";
import { Box } from "@chakra-ui/react";

// Opens the File picker when the child components get clicked
export default function FilePicker(props) {
  // Default props
  const noop = () => {}; // Default to no operation on change
  const defaultInputId = "__inputFilePicker_".concat(
    Math.floor(Math.random() * Math.floor(Number.MAX_SAFE_INTEGER))
  ); // Replace only if neccesary
  const defaultAccept = ".jpg, .jpeg, .png, .gif"; // Defaults to only image files
  const {
    onChange = noop,
    accept = defaultAccept,
    inputId = defaultInputId,
    isDisabled = false,
  } = props;

  function selectFile(e) {
    if (!isDisabled) document.getElementById(inputId).click();
  }

  return (
    <Box
      onClick={(e) => selectFile(e)}
      width="100%"
      height="100%"
      // This is a little hack. onMouseLeave get's triggered when the file picker is shown. This is causing issues with
      // the ControlShowcaseDesignBlockToolbar component, that relies on the onMouseLeave event for auto-closing the toolbar.
      // Without this line, the whole toolbar gets closed whenever any sub-component of it (like the product creation modal)
      // tries to use the FilePicker.
      // Avoid relying on the onMouseLeave event on this component's children.
      onMouseLeave={(event) => event.stopPropagation()}
    >
      {props.children}
      <input
        id={inputId}
        accept={accept}
        hidden
        type="file"
        onChange={(e) => {
          if ([...e.target.files][0]) onChange([...e.target.files][0]);
        }}
      />
    </Box>
  );
}
